import { ADD_NEW_URL_PART } from 'constants/URL'

export const EVENT_URL_PART = 'event'
export const NEWS_URL_PART = 'news'
export const FROM_CALENDAR_URL_PART = 'from_calendar'
export const COMPETITORS_URL_PART = 'competitors'
export const RESULTS_URL_PART = 'results'
export const SHEDULE_URL_PART = 'schedule'
export const PHOTOS_URL_PART = 'photos'
export const INFORMATION_URL_PART = 'info'
export const VIDEO_URL_PART = 'video'
export const APPLICATION_URL_PART = 'application'
export const EVENT_APPLICATION_URL_PART = 'applications'
export const EVENT_NEW_URL_PART = ADD_NEW_URL_PART
export const EVENT_ACCEPT_APPLICATIONS = 'accept_applications'
export const EVENT_VIDEO_TRANSLATION = 'translation'
export const EVENT_INSPECTION_COMMISSION = 'commission'
export const EVENT_MOBILE_JUDGE_URL_PART = 'judge'
export const EVENT_REFEERING_CODE_PAYGATE = 'refereeing-code-paygate'
export const EVENT_PROMOTION = 'promotion'
export const EVENT_PROMOTION_BANNER_PAYGATE = 'promotion-banner-paygate'
